<template>
  <section class="ammolite">
    <div class="ammolite__content container">
      <h2 class="ammolite__title --fade-in-up" data-vertical-ivp-class="--animate">What Is Ammolite?</h2>
      <p class="ammolite__description --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
        So, before diving too deep into the inner workings of the GEMXX company and what makes them so unique,
        it'd be good to get a brief on their top asset.
        <br><br>
        Ammolite is a gemstone that possesses a kaleidoscope-like display of colors. In fact,
        the highest grade ammolite stones can have a very distinct, infinite array of color combinations.
        It is only found in the Bearpaw geological formation along the eastern slopes of the Rocky Mountains,
        making it an incredibly rare resource. Interestingly, Ammolite comes from a 71-million year old fossil,
        but it was only actually discovered in the 20th century. The commercial market for this precious stone
        is new as well, having earned official gemstone status in 1981.
      </p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/ammolite.scss';
</style>

<script>
export default {
  name: 'Ammolite',
  data() {
    return {
    };
  },
};
</script>